import * as React from "react";

const IconTextLinkPlusHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M10.125 5.5a.75.75 0 01-.75.75H6v3.375a.75.75 0 11-1.5 0V6.25H1.125a.75.75 0 110-1.5H4.5V1.375a.75.75 0 111.5 0V4.75h3.375c.415 0 .75.335.75.75z"/></svg>;
};

export default React.memo(IconTextLinkPlusHover);
